import { IconSvgProps } from '../../../../../components/Icon/Icon';
import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';

export default function ChevronRight(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M17.2836 12C17.2836 11.7347 17.1868 11.5088 16.9826 11.3093L7.6152 2.2767C7.44107 2.09223 7.21048 2 6.94879 2C6.41508 2 6 2.40004 6 2.93843C6 3.18975 6.11297 3.42605 6.27206 3.60584L14.9814 12L6.27206 20.3941C6.11297 20.574 6 20.7999 6 21.0616C6 21.6 6.41508 22 6.94879 22C7.21048 22 7.44107 21.9078 7.6152 21.7233L16.9826 12.6907C17.1868 12.4912 17.2836 12.2653 17.2836 12Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
